module.exports = __webpack_public_path__ + "static/img/49441.9830ca0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/49441.jpg
// module id = zfzE
// module chunks = 1